import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { ISelection } from '../model/selections/Selection';
import { useParams } from 'react-router-dom';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useEntitySelectionsResult {
    isLoaded: boolean;
    selections: ISelection[];
}

export const useEntitySelections = () => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();
    const { gameEnv } = useParams<{ gameEnv: string }>();

    const [result, setResult] = useState<useEntitySelectionsResult>(() => ({ isLoaded: false, selections: [] }));

    // Note:  This should be dependent on rootStore.currentGameEnvironment but this introduces issues due to useEffects
    // running bottom to top.  What happens is that useEffects further down the chain will end up running twice when
    // rootoStore.currentGameEnvironment changes (i.e once before they are removed from the tree and once when they are added back in the tree)
    // Making this dependent on the param means that it will run before those further down the tree,   that are dependent on
    // rootStore.currentGameEnvironment, which will remove them from the tree before their useEffects run. See Entities.tsx
    useEffect(() => {
        setResult({ isLoaded: false, selections: [] });
        rootStore.entitySelectionStore.loadSelections()
            .then(() => {
                setResult({ isLoaded: true, selections: rootStore.entitySelectionStore.getSelections() });
            })
            .catch(e => publishNotification({
                text: `Error finding entity selections: ${e.message}`,
                canClose: true
            }));
    }, [rootStore.entitySelectionStore, publishNotification, rootStore.gameVersionStore.currentGameVersion, gameEnv]);

    return result;
};
